import isEmpty from 'lodash/isEmpty'
import {
  salesPhone, shoppingPhone, whatsapp, whatsappVTA,
} from 'vars'

/**
 * Interruptor del *call tracking* por canal.
 *
 * Cuando está activo, los teléfonos del sitio salen de `/api/contact_numbers`,
 * que devuelve un número distinto por campaña (Orgánico, Google, Youtube…) para
 * poder medir de dónde llegan las llamadas. Ese mecanismo pisa las constantes
 * de `vars.js`, así que cambiarlas ahí no tenía ningún efecto en producción.
 *
 * Se desactiva porque hoy ClikAuto opera con un único número de contacto. Con
 * el interruptor en `false` el sitio usa las constantes de `vars.js` y el
 * número nuevo aplica de inmediato, sin depender de que backend actualice las
 * 14 filas de la API.
 *
 * Para volver a medir por campaña basta con ponerlo en `true`: la lógica de
 * abajo quedó intacta a propósito.
 */
const USE_CHANNEL_TRACKING = false

export const getPhonesByChannel = (query, phones = []) => {
  if (!USE_CHANNEL_TRACKING) {
    // Se devuelven las mismas llaves que en el flujo normal para no cambiar el
    // contrato con `_app.js` ni con los componentes que las leen.
    return ({
      fuente: undefined,
      whatsapp,
      whatsappVTA,
      salesPhone,
      shoppingPhone,
    })
  }

  let finalPhones = []
  const referrer = typeof window !== 'undefined' ? window.document.referrer : ''
  const getQuery = { ...query }
  if (!phones) return []
  if (isEmpty(getQuery) && !isEmpty(referrer)) {
    if (referrer.includes('facebook')) {
      getQuery.utm_source = 'facebook'
      getQuery.utm_medium = ''
    }
    if (referrer.includes('google')) {
      getQuery.utm_source = 'google'
      getQuery.utm_medium = ''
    }
  }
  if ((isEmpty(getQuery) && isEmpty(referrer)) || !('utm_source' in getQuery)) {
    getQuery.utm_source = 'default'
    getQuery.utm_medium = ''
  }

  finalPhones = phones.find(
    (item) => (item.utm_source === getQuery?.utm_source
      && item.utm_medium === getQuery?.utm_medium),
  )

  // if (finalPhones?.length === 0) {
  //   finalPhones = phones.find(
  //     (item) => (item.utm_source === 'default'
  //       && item.utm_medium === ''),
  //   )
  // }

  return ({
    fuente: finalPhones?.fuente,
    whatsapp: finalPhones
      ? finalPhones?.num_whatsapp_compras
      : whatsapp,
    whatsappVTA: finalPhones
      ? finalPhones?.num_whatsapp_ventas
      : whatsappVTA,
    salesPhone: finalPhones
      ? finalPhones?.num_llamada_ventas
      : salesPhone,
    shoppingPhone: finalPhones
      ? finalPhones?.num_llamada_compras
      : shoppingPhone,
  })
}
